export enum EMonth {
  JANUARY = 'january',
  FEBRUARY = 'february',
  MARCH = 'march',
  APRIL = 'april',
  MAY = 'may',
  JUNE = 'june',
  JULY = 'july',
  AUGUST = 'august',
  SEPTEMBER = 'september',
  OCTOBER = 'october',
  NOVEMBER = 'november',
  DECEMBER = 'december',
}

export interface ISelectOption {
  id: string | number;
  name?: string;
  label?: string;
  value?: string;
}

export interface AppImage {
  id: number;
  name: string;
  url: string;
  ext: string;
  size: number;
}

export interface AppCompany {
  id: number;
  name: string;
}

export interface ICompanyUser {
  id: number;
  first_name: string;
  last_name: string;
}
